import React from 'react';

import { DocumentComponents, DocumentNode } from '../types';

export interface DocumentNodeCache {
  element?: React.ReactElement;
  node?: DocumentNode;
  children?: DocumentNodeCache[];
}

export function renderNode(
  node: DocumentNode,
  components: DocumentComponents,
  path: number[] = [],
  cache: DocumentNodeCache = {},
): React.ReactElement | null {
  const Component = components[node.type] as React.ElementType<any>;
  if (!Component) {
    console.error(`Invalid component type: ${node.type}`);
    return null;
  }
  const pathKey = node.key ?? path[path.length - 1];
  // Check if the cache can be reused
  if (cache.node === node && cache.element != null) {
    return cache.element;
  }
  const childrenArr = cache.children ?? [];
  cache.children = childrenArr;
  let result: React.ReactElement;
  if (node.children.length > 0) {
    result = (
      <Component {...node.props} key={pathKey} path={path}>
        { node.children
          .map((node, i) => {
            const childCache = childrenArr[i] ?? {};
            const result = renderNode(
              node,
              components,
              [...path, i],
              childCache,
            );
            childrenArr[i] = childCache;
            return result;
          }) }
      </Component>
    );
  } else {
    result = (
      <Component {...node.props} key={pathKey} path={path} />
    );
  }
  cache.node = node;
  cache.element = result;
  return result;
}
